import script from "./RenderSlot.vue?vue&type=script&lang=ts"
export * from "./RenderSlot.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__